import './Share.css';
import { h } from 'preact';
import BaseComponent from '../BaseComponent';
import { urlEncode } from 'Services/Misc/format';
import { UI } from 'StateEvents';
import { update } from 'Emitter';
import copy from 'copy-to-clipboard';

export default class Share extends BaseComponent {
  constructor(state) {
    super(state);
    this.icons = [
      { code: 'info', event: UI.CLICKED, action: click => this.openWindow(click) },
      { code: 'fb',   event: UI.SHARED,  action: click => this.openWindow(`https://www.facebook.com/share.php?u=${urlEncode(click)}`) },
      { code: 'tw',   event: UI.SHARED,  action: click => this.openWindow(`https://twitter.com/intent/tweet?text=${urlEncode('Check this out!')}&url=${click}`) },
      { code: 'link', event: UI.SHARED,  action: click => copy(click) }
    ]
  }

  onShare(icon, event) {
    update(icon.event, 'onShare', icon.code);
    event.preventDefault();
    icon.action(this.props.options.click);
  }

  openWindow(click) {
    window.open(click, '_blank');
  }

  shareIcon(icon) {
    return (
      <li data-img={ icon.code } onClick={ this.onShare.bind(this, icon) }>
        <a href="#"></a>
      </li>
    )
  }

  render(props) {
    if(props.options.share && props.options.click) {
      return (
        <div class="share">
          <ul> { this.icons.map(this.shareIcon.bind(this)) } </ul>
        </div>
      )
    }

    return null;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/Share/Share.js